"use strict";
/**
 * 清理所有 zustand stores 的快取
 *
 * 用於登出時清理所有持久化的 store 資料，防止資料混淆
 *
 * @example
 * ```typescript
 * import { clearAllStores } from '@redpanda/utils';
 *
 * const logout = () => {
 *   clearAllStores({
 *     '../stores/customerStore': ['useCustomerStoreBase', 'useArchivedCustomerStoreBase'],
 *     '../stores/tagStore': ['useTagStoreBase'],
 *   });
 *   // ... 其他清理邏輯
 * };
 * ```
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearStoresByPattern = exports.clearAllStores = void 0;
/**
 * 批次清理多個 zustand stores 的快取
 *
 * @param storeConfig - store 配置對象，key 是 store 檔案路徑，value 是導出的 store 名稱陣列
 */
const clearAllStores = (storeConfig) => {
    Object.entries(storeConfig).forEach(([storePath, storeNames]) => {
        Promise.resolve(`${storePath}`).then(s => __importStar(require(s))).then((module) => {
            storeNames.forEach((storeName) => {
                const store = module[storeName];
                if (store?.getState) {
                    const state = store.getState();
                    if (typeof state.invalidateCache === 'function') {
                        state.invalidateCache();
                    }
                    else if (typeof state.clearCache === 'function') {
                        state.clearCache();
                    }
                }
            });
        })
            .catch((error) => {
            // 靜默失敗，不影響其他 store 的清理
            console.debug(`Failed to clear store ${storePath}:`, error);
        });
    });
};
exports.clearAllStores = clearAllStores;
/**
 * 簡化版：清理單一類型的 stores（所有都導出相同名稱的 hook）
 *
 * @example
 * ```typescript
 * clearStoresByPattern([
 *   '../stores/customerStore',
 *   '../stores/tagStore',
 * ], 'default'); // 會呼叫每個模組的 default export
 * ```
 */
const clearStoresByPattern = (storePaths, exportName = 'default') => {
    const config = {};
    storePaths.forEach((path) => {
        config[path] = [exportName];
    });
    (0, exports.clearAllStores)(config);
};
exports.clearStoresByPattern = clearStoresByPattern;
